import Bs4MainDispatch from './Bs4MainDispatch';

function cloneAsObject(obj) {
  if (obj === null || !(obj instanceof Object)) {
      return obj;
  }
  var temp = (obj instanceof Array) ? [] : {};
  // ReSharper disable once MissingHasOwnPropertyInForeach
  for (var key in obj) {
      temp[key] = cloneAsObject(obj[key]);
  }
  return temp;
}

export const geolocation = (message) => {  
  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0,
  };
  
  function success(pos) {    
    // console.log('...GeolocationPosition...:', cloneAsObject(pos));
    Bs4MainDispatch.commandParser('bs4GeolocationCoordinates', {
      GeolocationPosition: cloneAsObject(pos),
      bs4_hash_id: message._Komunikat,
    }, null);
  }
  
  function error(err) {
    // console.log(`ERROR(${err.code}): ${err.message}`);
    Bs4MainDispatch.commandParser('bs4GeolocationCoordinates', {
      error: cloneAsObject(err),
      bs4_hash_id: message._Komunikat,
    }, null);
  }
  
  navigator.geolocation.getCurrentPosition(success, error, options);
}